const HTML_TAG_PATTERN = /<[^>]*>/gu;
const WHITESPACE_PATTERN = /\s+/gu;
const DEFAULT_PREVIEW_MAX_LENGTH = 500;
const PREVIEW_ELLIPSIS_LENGTH = 3;

export const stripHtmlToPlainText = (html: string): string => html
    .replace(HTML_TAG_PATTERN, ' ')
    .replace(WHITESPACE_PATTERN, ' ')
    .trim();

const truncateFaqPreviewText = (text: string, maxLength: number): string => {
    if (text.length <= maxLength) {
        return text;
    }

    return `${text.slice(0, maxLength - PREVIEW_ELLIPSIS_LENGTH)}...`;
};

export const buildFaqPreviewText = (html: string, maxLength = DEFAULT_PREVIEW_MAX_LENGTH): string => {
    const plainText = stripHtmlToPlainText(html);

    return truncateFaqPreviewText(plainText, maxLength);
};
